import React from 'react';

import styled, { css } from 'styled-components';

export interface MenuButtonProps {
  onClick: () => void;
  isOpened: boolean;
}

function MenuButton({ onClick, isOpened }: MenuButtonProps) {
  return (
    <Wrapper onClick={onClick}>
      <TopLine isOpened={isOpened} />
      <CenterLine isOpened={isOpened} negative />
      <CenterLine isOpened={isOpened} />
      <BottomLine isOpened={isOpened} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;

  width: 21px;
  height: 16px;

  cursor: pointer;
`;

const Line = styled.div`
  position: absolute;
  left: 0;

  width: 100%;
  height: 2px;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 9px;

  transition: 0.2s;
`;

interface LineProps {
  isOpened: MenuButtonProps['isOpened'];
  negative?: boolean;
}

const TopLine = styled(Line)<LineProps>`
  top: 0;

  ${({ isOpened }) =>
    isOpened &&
    css`
      top: 7px;
      width: 0;
      left: 50%;
    `}
`;

const CenterLine = styled(Line)<LineProps>`
  top: 7px;

  ${({ isOpened, negative }) =>
    isOpened &&
    css`
      transform: rotate(${negative ? '-' : ''}45deg);
    `}
`;

const BottomLine = styled(Line)<LineProps>`
  top: 14px;

  ${({ isOpened }) =>
    isOpened &&
    css`
      top: 7px;
      width: 0;
      left: 50%;
    `}
`;

export default MenuButton;
